function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
export var IconSettingsContext = /*#__PURE__*/ React.createContext({});
var IconSettingsProvider = function(_param) {
    var children = _param.children, settings = _objectWithoutProperties(_param, [
        "children"
    ]);
    var contextValue = React.useMemo(function() {
        return settings;
    }, [
        settings.classPrefix,
        settings.globalClasses
    ]);
    return /*#__PURE__*/ React.createElement(IconSettingsContext.Provider, {
        value: contextValue
    }, children);
};
export { IconSettingsProvider };
